import { useItemSquares } from 'global/cnr/contexts/useHelpers/useItemSquares'
import React, { useContext, useMemo } from 'react'
import ItemMenuSquares from './ItemMenuSquares'
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { _longPressDisplayTypes, _longPressTypes } from './LongPressWrapper';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { gEnums } from 'global/enums/globalEnums';
import { convertHelpers } from 'global/common/convert';
import { ElementContext } from 'global/cnr/contexts/ElementContext';
import { UiItemContext } from 'global/cnr/contexts/UiItemContext';
import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';

export const SquaresLongPress = (
  {
    handleClick_action,
    handleClick_item,
    handleClick_nav,
    handleClick_navPath,
    longPressType,
    longPressDisplayType
  }
) => {

  const _aal = gEnums.allAuthLevels

  const appUserAccess = useAppUserAccess()

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, currentSettings_state, paps_state } = states
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appSettings } = aps_global ?? {};
  const { pathViews } = paps_state ?? {}
  const { app_metas } = app_state ?? {}
  const { showQrCodeDirect } = appSettings ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { permissionGroups } = framework_state ?? {}
  const {
    admin: pgs_admin,
    appAdmin: pgs_appAdmin,
    pageHidden: pgs_pageHidden,
    ticketing: pgs_ticketing,
  } = permissionGroups ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { viewItem_key: viKey } = item_state ?? {}

  // elementContext
  const elementContext = useContext(ElementContext)
  const { element_state } = elementContext ?? {}
  const { itemData: itemData_elem } = element_state ?? {}

  const {
    _dmo_list,
    _dmo_solo,
    _dmo_subList,
    actions_admin,
    actions_superAdminDeveloper,
    actions_appUser_scans,
    actions_appUser,
    actions_banner,
    actions_image,
    actions_item_scans,
    actions_item,
    actions_pageSettings,
    actions_settings,
    actions_app,
  } = useItemSquares()

  const name = convertHelpers.getItemName(itemData_elem, null, null, true)

  const cn_squares = useMemo(() => {
    let _cn = 'menu-squares'
    switch (longPressDisplayType) {
      case _longPressDisplayTypes.partial:
        _cn += ' overlay'
        break;
      default:
      // nothing
    }
  }, [])

  const access = useMemo(() => {
    if (!appUserAccess) { return {} }
    const _access = {
      appProfile: { allowed: appUserAccess.accessLevel >= _aal.appProfile.value, color: _aal.appProfile.color, icon: _aal.appProfile.icon },
      superAdminDeveloper: { allowed: appUserAccess.accessLevel >= _aal.superAdminDeveloper.value, color: _aal.superAdminDeveloper.color, icon: _aal.superAdminDeveloper.icon },
      superAdmin: { allowed: appUserAccess.accessLevel >= _aal.superAdmin.value, color: _aal.superAdmin.color, icon: _aal.superAdmin.icon },
      appDataAdmin: { allowed: appUserAccess.accessLevel >= _aal.appDataAdmin.value, color: _aal.appDataAdmin.color, icon: _aal.appDataAdmin.icon },
      appAdmin: { allowed: appUserAccess.accessLevel >= _aal.appAdmin.value, color: _aal.appAdmin.color, icon: _aal.appAdmin.icon },
    }
    switch (longPressType) {
      case _longPressTypes.appUser:
        _access.any = _access.superAdmin || _access.appDataAdmin || _access.appAdmin || _access.appProfile
        break;
      default:
        _access.any = _access.superAdmin || _access.appDataAdmin || _access.appAdmin
    }
    return _access
  }, [appUserAccess, longPressType])

  const item_nav = (key, caption, icon, iconColor, itemKey, pageKey) => {
    return { caption, key, icon, iconColor, itemKey, pageKey, altContent: key }
  }

  const squares_permissionsNav = (items, navCaption, icon, access) => {
    const _menuItems = []
    _.forEach(items, (item, key) => {
      const { segProps, itemKey } = item
      const { caption, icon } = segProps
      _menuItems.push(item_nav(null, caption, icon, 'blue', itemKey, key))
    })
    return <ItemMenuSquares caption={navCaption} menuItems={_menuItems} onClick={handleClick_nav} icon={icon || 'computer'} iconColor={access.color} access={access} />
  }

  const squares_environment = () => {
    const _menuItems = []
    _menuItems.push(item_nav('auth', app_metas?.auth?.appName, 'user secret'))
    _menuItems.push(item_nav('fn', app_metas?.functions?.appName, 'code'))
    _menuItems.push(item_nav('fs', app_metas?.firestore?.appName, 'database'))
    _menuItems.push(item_nav('mess', app_metas?.messaging?.appName, 'send'))
    _menuItems.push(item_nav('rt', app_metas?.rtdb?.appName, 'database'))
    return <ItemMenuSquares caption={`Environment`} menuItems={_menuItems} onClick={handleClick_action} icon={'list'} fullRow={true} />
  }

  const squares_goto = () => {
    const _menuItems = []
    _menuItems.push(item_nav('home', 'Home', 'home', 'blue'))
    pathViews.events && _menuItems.push(item_nav('client', 'Client', 'handshake', 'blue'))
    return <ItemMenuSquares caption={`Goto`} menuItems={_menuItems} onClick={handleClick_navPath} icon={'list'} />
  }

  const ims = (menuItems, caption, icon, oc, access) => menuItems && <ItemMenuSquares caption={caption} menuItems={menuItems} onClick={oc} icon={icon} access={access} />

  const isms = useMemo(() => {

    const oc_a = handleClick_action
    const oc_i = handleClick_item

    const _isms_superAdminDeveloper = {
      superAdminDeveloper: access.superAdminDeveloper.allowed && ims(actions_superAdminDeveloper, 'Admin', 'list', oc_a, access.superAdminDeveloper),
    }

    const _isms_superAdmin = {
      admin: access.superAdmin.allowed && ims(actions_admin, 'Admin', 'list', oc_a, access.superAdmin),
      appData: access.superAdmin.allowed && ims(actions_app, 'App', 'list', oc_a, access.superAdmin),
      image: access.superAdmin.allowed && ims(actions_image, 'Image', 'list', oc_a, access.superAdmin),
      item: access.superAdmin.allowed && ims(actions_item, 'Item', 'list', oc_a, access.superAdmin),
      itemScans: access.superAdmin.allowed && ims(actions_item_scans, `Scans (${name})`, 'list', oc_a, access.superAdmin),
      permissions_admin: access.superAdmin.allowed && squares_permissionsNav(pgs_admin, 'Admin', 'list', access.superAdmin),
      goto: access.superAdmin.allowed && squares_goto(),
      environment: access.superAdmin.allowed && squares_environment(),
    }

    const _ims_admin = {}

    const _ims_appAdmin = {
      banner: access.appAdmin.allowed && ims(actions_banner, 'Banner', 'list', oc_a, access.appAdmin),
      pageSettings: access.appAdmin.allowed && ims(actions_pageSettings, 'Settings', 'list', oc_a, access.appAdmin),
      scans: access.appAdmin.allowed && ims(actions_item_scans, 'App Scans', 'list', oc_a, access.appAdmin),
      settings: access.appAdmin.allowed && ims(actions_settings, 'Settings', 'list', oc_a, access.appAdmin),
      ticketing: access.appAdmin.allowed && squares_permissionsNav(pgs_ticketing, 'Ticketing', 'list', access.appAdmin),
      permissions_appAdmin: access.appAdmin.allowed && squares_permissionsNav(pgs_appAdmin, 'App Admin', 'list', access.appAdmin),
      permissions_adminHidden: access.superAdmin.allowed && squares_permissionsNav(pgs_pageHidden, 'Hidden', 'list', access.appAdmin),
    }

    const _ims_appDataAdmin = {
      listData: access.appDataAdmin.allowed && ims(_dmo_list, `List (${_.startCase(viKey)})`, 'list', oc_i, access.appDataAdmin),
      soloData: access.appDataAdmin.allowed && ims(_dmo_solo, `Item (${name})`, 'list', oc_i, access.appDataAdmin.color, access.appDataAdmin),
      subListData: access.appDataAdmin.allowed && ims(_dmo_subList, `Sub List (${_.startCase(viKey)})`, 'list', oc_i, access.appDataAdmin),
    }

    const _ims_appProfile = {
      appUser: access.appProfile.allowed && ims(actions_appUser, 'App User', 'list', oc_a),
      appUserScans: access.appProfile.allowed && ims(actions_appUser_scans, 'Scans', 'list', oc_a),
    }

    const _isms = {
      ..._isms_superAdminDeveloper,
      ..._isms_superAdmin,
      ..._ims_admin,
      ..._ims_appAdmin,
      ..._ims_appDataAdmin,
      ..._ims_appProfile,
    }
    return _isms
  })

  const squares_main = () => <div className={cn_squares}>
    {isms.settings}
    {/* {access.settings.allowed && <ItemMenuSquares caption={`Settings`} menuItems={actions_settings} onClick={handleClick_action} icon={'settings'} />} */}
  </div>

  const squarez_item = () => <div className={cn_squares}>
    {isms.item}
    {isms.scans}
    {isms.soloData}
    {isms.listData}
    {isms.subListData}
    {isms.settings}
    {isms.admin}
    {isms.superAdminDeveloper}
    {showQrCodeDirect && <div style={{ padding: '4em 0' }}>
      <QrCode itemData={itemData_elem} itemType={itemData_elem._itemKey} qrCodeType={gEnums.qrCodeTypes.itemData} />
    </div>}
  </div>

  const squares_settings = () => {
    return <div className={cn_squares}>
      {isms.image}
      {/* {access.data && <ItemMenuSquares caption={'Data'} menuItems={_dmos} onClick={handleClick_item} icon={'database'} />} */}
      {/* {access.auth.allowed && !_.isEmpty(actions_image) && <ItemMenuSquares fullRow={true} withCancel={true} onCancel={handleCancel} caption={`Image`} menuItems={actions_image} onClick={handleClick_action} icon={'user secret'} />} */}
    </div>
  }


  /**
   * 
   * @returns a group of squres for the current App User
   */
  const squarez_appUser = () => <div className={cn_squares}>
    {isms.appUser}
    {isms.settings}
    {isms.appUserScans}
    {isms.ticketing}
    {isms.permissions_admin}
    {isms.permissions_appAdmin}
    {isms.permissions_adminHidden}
    {isms.superAdminDeveloper}
    {isms.goto}
    {isms.appData}
    {isms.environment}
    {showQrCodeDirect && <div style={{ padding: '4em 0' }}>
      <QrCode itemData={appUserAccess} itemType={appUserAccess.uid} qrCodeType={gEnums.qrCodeTypes.appUser} />
    </div>}
  </div>

  const squares_banner = () => <div className={cn_squares}>
    {access.appAdmin.allowed && !_.isEmpty(actions_banner) && <ItemMenuSquares caption={`Banner`} menuItems={actions_banner} onClick={handleClick_action} icon={'settings'} />}
  </div>

  const squarez_content = useMemo(() => {
    switch (longPressType) {
      case _longPressTypes.header:
        return squares_main()
      case _longPressTypes.appUser:
        return squarez_appUser()
      case _longPressTypes.bannerImage:
        return squares_banner()
      case _longPressTypes.image_grid:
        return squares_settings()
      default:
        return squarez_item()
    }
  }, [longPressType])

  return squarez_content

}
